import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logoImage from "../assets/images/logo.png";

const currentDate = new Date().toLocaleString();

export const generateFullReportPDF = (reports, action) => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  const addHeader = () => {
    doc.setFont("Times", "bold");
    doc.setFontSize(14);
    doc.setTextColor(4, 4, 252);

    doc.text("EAST AFRICAN COMMUNITY", doc.internal.pageSize.width / 2, 15, {
      align: "center",
    });
    doc.text("SECRETARIAT", doc.internal.pageSize.width / 2, 21, {
      align: "center",
    });

    //Logo image
    const logoWidth = 32;
    const logoHeight = 28;
    const logoX = (doc.internal.pageSize.width - logoWidth) / 2;
    doc.addImage(logoImage, "JPEG/PNG", logoX, 22, logoWidth, logoHeight);

    // Left-side contact details
    doc.setFontSize(8);
    doc.setFont("Times", "normal");
    doc.setTextColor(13, 13, 13);
    doc.text("EAC Close, Afrika Mashariki Road,", 30, 33);
    doc.text("P.O. Box 1096", 30, 37);
    doc.text("ARUSHA, TANZANIA", 30, 41);

    // Right-side contact details
    doc.text("Tel: +255-27-2504253/8", doc.internal.pageSize.width - 35, 33, {
      align: "right",
    });
    doc.text(
      "Fax: +255-27-2504255/2504481",
      doc.internal.pageSize.width - 35,
      37,
      {
        align: "right",
      }
    );
    doc.text("Email: eac@eachq.org", doc.internal.pageSize.width - 35, 41, {
      align: "right",
    });
    doc.text("Web: http://www.eac.int", doc.internal.pageSize.width - 35, 45, {
      align: "right",
    });

    // Title of the report
    doc.setFontSize(12);
    doc.setFont("Times", "bold");
    doc.setTextColor(83, 83, 83);
    doc.text("Internship Programme Reports", pageWidth / 2, 58, {
      align: "center",
    });

    // line under the header
    doc.setDrawColor(12, 115, 38);
    doc.setLineWidth(0.7);
    doc.line(15, 62, pageWidth - 15, 62);
  };

  doc.setFontSize(7);
  doc.setTextColor(13, 13, 13);
  doc.text(`Date Generated: ${currentDate}`, pageWidth - 15, 66, {
    align: "right",
  });

  //footer with page numbers
  const addFooter = () => {
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(7);
      doc.setTextColor(100);
      doc.text(`Page ${i} of ${pageCount}`, pageWidth - 20, pageHeight - 8, {
        align: "right",
      });
      doc.text("Generated by Internship Management System", 20, pageHeight - 8);
    }
  };

  // Extracting report data into rows
  const tableRows = reports.map((report, index) => [
    index + 1,
    `${report.surname || ""} ${report.firstName || ""} ${
      report.otherNames || ""
    }`,
    report.internshipDepartment || "N/A",
    report.internshipSupervisor || "N/A",
    report.internshipStartDate
      ? new Date(report.internshipStartDate).toLocaleDateString()
      : "N/A",
    report.internshipEndDate
      ? new Date(report.internshipEndDate).toLocaleDateString()
      : "N/A",
    report.applicationStatus || "N/A",
  ]);

  addHeader();

  // detailed internship report table
  autoTable(doc, {
    head: [
      [
        "#",
        "Name",
        "Department",
        "Supervisor",
        "Start Date",
        "End Date",
        "Status",
      ],
    ],
    body: tableRows,
    startY: 70,
    theme: "striped",
    headStyles: {
      fillColor: [12, 115, 38],
      textColor: [255, 255, 255],
      fontSize: 9,
      halign: "start",
    },
    bodyStyles: { fontSize: 8 },
    alternateRowStyles: { fillColor: [245, 245, 245] },
    pageBreak: "auto",
  });

  addFooter();

  // Save the PDF with a unique name
  doc.save("internship_full_report.pdf");
};

export const generateReportPDF = (report) => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const currentDate = new Date().toLocaleString();

  const addHeader = () => {
    doc.setFont("Times", "bold");
    doc.setFontSize(14);
    doc.setTextColor(4, 4, 252);

    doc.text("EAST AFRICAN COMMUNITY", doc.internal.pageSize.width / 2, 15, {
      align: "center",
    });
    doc.text("SECRETARIAT", doc.internal.pageSize.width / 2, 21, {
      align: "center",
    });

    //Logo image
    const logoWidth = 32;
    const logoHeight = 28;
    const logoX = (doc.internal.pageSize.width - logoWidth) / 2;
    doc.addImage(logoImage, "JPEG/PNG", logoX, 22, logoWidth, logoHeight);

    // Left-side contact details
    doc.setFontSize(8);
    doc.setFont("Times", "normal");
    doc.setTextColor(13, 13, 13);
    doc.text("EAC Close, Afrika Mashariki Road,", 30, 33);
    doc.text("P.O. Box 1096", 30, 37);
    doc.text("ARUSHA, TANZANIA", 30, 41);

    // Right-side contact details
    doc.text("Tel: +255-27-2504253/8", doc.internal.pageSize.width - 35, 33, {
      align: "right",
    });
    doc.text(
      "Fax: +255-27-2504255/2504481",
      doc.internal.pageSize.width - 35,
      37,
      {
        align: "right",
      }
    );
    doc.text("Email: eac@eachq.org", doc.internal.pageSize.width - 35, 41, {
      align: "right",
    });
    doc.text("Web: http://www.eac.int", doc.internal.pageSize.width - 35, 45, {
      align: "right",
    });

    // Title of the report
    doc.setFontSize(12);
    doc.setFont("Times", "bold");
    doc.setTextColor(83, 83, 83);
    doc.text("Individual Internship Report", pageWidth / 2, 58, {
      align: "center",
    });

    // line under the header
    doc.setDrawColor(12, 115, 38);
    doc.setLineWidth(0.7);
    doc.line(15, 62, pageWidth - 15, 62);
  };
  addHeader();

  doc.setFontSize(7);
  doc.setTextColor(13, 13, 13);
  doc.text(`Date Generated: ${currentDate}`, pageWidth - 15, 66, {
    align: "right",
  });
  doc.setFont("Times", "bold");
  doc.setFontSize(14);
  doc.text("Internship Applicant Information", 20, 70);

  doc.setFont("Times", "bold");
  doc.setFontSize(11);
  const startY = 79; // Starting Y position for details
  const lineHeight = 10; // Line height for spacing
  let currentY = startY;

  // array of applicant details to iterate over
  const details = [
    {
      label: "Name:",
      value: `${report.surname || ""} ${report.firstName || ""} ${
        report.otherNames || ""
      }`,
    },
    { label: "Department:", value: report.internshipDepartment || "N/A" },
    { label: "Supervisor:", value: report.internshipSupervisor || "N/A" },
    { label: "Email:", value: report.email || "N/A" },
    { label: "Phone:", value: report.phoneNumber || "N/A" },
    {
      label: "Start Date:",
      value: report.internshipStartDate
        ? new Date(report.internshipStartDate).toLocaleDateString()
        : "N/A",
    },
    {
      label: "End Date:",
      value: report.internshipEndDate
        ? new Date(report.internshipEndDate).toLocaleDateString()
        : "N/A",
    },
    { label: "Status:", value: report.applicationStatus || "N/A" },
    {
      label: "Emergency Contact Name:",
      value: report.emergencyContactPerson || "N/A",
    },
    {
      label: "Emergency Contact Phone:",
      value: report.emergencyContactPhone || "N/A",
    },
    {
      label: "Insurance Policy No:",
      value: report.insurancePolicyNumber || "N/A",
    },
    { label: "Insurance Company:", value: report.insuranceCompany || "N/A" },
    { label: "Institution:", value: report.institutionName || "N/A" },
  ];

  // Looping through details and adding them to the PDF
  details.forEach((detail) => {
    doc.setFont("Times", "bold");
    doc.text(detail.label, 30, currentY);
    doc.setFont("Times", "normal");

    // Checking if detail value is valid and converting to string
    const detailValue = String(detail.value);
    doc.text(detailValue, 90, currentY);
    currentY += lineHeight;
  });

  const pageHeight = doc.internal.pageSize.getHeight();
  doc.setFontSize(7);
  doc.setTextColor(100);
  doc.text("Generated by Internship Management System", 20, pageHeight - 8);
  doc.text(`Page 1`, pageWidth - 20, pageHeight - 8, { align: "right" });

  // Saving the PDF with a unique name
  doc.save(
    `${report?.surname} ${report?.firstName} ${report?.otherNames}-Internship_Report.pdf`
  );
};
